import React from 'react';

import { Result, Button } from 'antd';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'react-error-boundary';

import { useRouter } from 'hooks/useRouter';

LoggingErrorBoundary.propTypes = {
	children: PropTypes.node,
	FallbackComponent: PropTypes.node,
};

LoggingErrorBoundary.DefaultFallback = function DefaultFallback() {
	const { pathname } = useRouter();
	return (
		<div className="full-height">
			<Result
				status="500"
				subTitle="An unexpected error has occurred"
				extra={
					<Button type="primary" href={pathname}>
						Refresh
					</Button>
				}
			/>
		</div>
	);
};

LoggingErrorBoundary.DefaultFallback.propTypes = {
	error: PropTypes.object,
};

export default function LoggingErrorBoundary({
	children,
	FallbackComponent = LoggingErrorBoundary.DefaultFallback,
}) {
	const onError = (error, info) => {
		console.error(
			'[ErrorBoundary caught an error]',
			error,
			info?.componentStack,
		);
	};

	return (
		<ErrorBoundary FallbackComponent={FallbackComponent} onError={onError}>
			{children}
		</ErrorBoundary>
	);
}
